import React, { useState, useEffect } from 'react';
import { Grid, TextField } from '@mui/material';
import Button from 'react-bootstrap/Button';
import APIService from '../../../../APIService';
import swal from 'sweetalert';
import { Table } from 'react-bootstrap';

export default function License() {

  const [licensees, setLicensees] = useState([])
  const [heading, setHeading] = useState("");
  const [address, setAddress] = useState("");
  const [fax, setFax] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [fileUpload, setFileUpload] = useState("");

  const [licenseId, setLicenseId] = useState("");
  const [isEditing, setIsEditing] = useState(false);


  useEffect(() => {
    APIService.get('licensees').then((response) => {
      setLicensees(response.data);
    });  
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
  }, []);
  const handleFileChange = (e) => {
    if (e.target.files) {
      setFileUpload(e.target.files[0]);
    }
  }


  const handleEdit = (itemId, heading, address, fax, phone, email) => {
    setIsEditing(true);
    setLicenseId(itemId);
    setHeading(heading);
    setAddress(address)
    setFax(fax)
    setPhone(phone);
    setEmail(email)
  };


  const handleDelete = (itemId) => {
    // e.preventDefault();
    swal({
      title: "Are you sure?",
      text: "You want to delete this item?",
      icon: "warning",
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        APIService.delete(`licensees/${itemId}`).then((response) => {
          swal("Success", response.message, "success", {
            buttons: false,
            timer: 2000,
          }).then((value) => {
            window.location.href = "/license";
          });
        });
      }
    });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("heading", heading);
    formData.append("address", address);
    formData.append("fax", fax);
    formData.append("phone", phone);
    formData.append("email", email);
    formData.append("file_upload", fileUpload);

    if (isEditing) {
      var response = await APIService.put(formData, `licensees/${licenseId}`);
    } else {
      var response = await APIService.post(formData, "licensees");
    }

    if (response.success) {
      swal("Success", response.message, "success", {
        buttons: false,
        timer: 2000,
      }).then((value) => {
        window.location.href = "/license";
      });
    } else {
      swal("Failed", response.message, "error");
    }
  }

  return (
    <div>
      <h2 className="organisation-head">Licensees</h2>
      <form noValidate onSubmit={handleSubmit}>
        <Grid container spacing={3} style={{ marginTop: 10 }}>
          <Grid item xs={12} sm={6} lg={4}>
            <p id="labels">Heading</p>
            <TextField
              name="heading"
              label="Heading"
              variant="outlined"
              fullWidth
              value={heading}
              onChange={e => setHeading(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <p id="labels">Upload File</p>
            <TextField
              name="upload-photo"
              type="file"
              onChange={handleFileChange}
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: 10 }}>
          <Grid item xs={12} sm={6} lg={12} md={8}>
            <p id="labels">Address</p>
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label="Address"
              multiline
              rows={3}
              value={address}
              onChange={e => setAddress(e.target.value)}
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: 10 }}>
          <Grid item xs={12} sm={6} lg={4}>
            <p id="labels">Phone Number</p>
            <TextField
              name="phn_number"
              label="Phone Number"
              variant="outlined"
              fullWidth
              value={phone}
              onChange={e => setPhone(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <p id="labels">Fax</p>
            <TextField
              name="fax"
              label="Fax"
              variant="outlined"
              fullWidth
              value={fax}
              onChange={e => setFax(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <p id="labels">Email</p>
            <TextField
              name="email"
              label="Email"
              variant="outlined"
              fullWidth
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </Grid>
        </Grid>
        <Button style={{ marginTop: 20 }} variant="primary" type="submit">Submit</Button>{' '}
      </form>
      <Table striped bordered hover variant="light">
        <thead>
          <tr>
            <th>SL No</th>
            <th>Title</th>
            <th>Email</th>
            <th>Address</th>
            <th>Fax</th>
            <th>Phone</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>

          {licensees.map((license, index) => (
            <tr key={license.id}>
              <td>{index + 1}</td>
              <td>{license.heading}</td>
              <td>{license.email}</td>
              <td>{license.address}</td>
              <td>{license.fax}</td>
              <td>{license.phone}</td>
              <td><button className='tablebutton'
               onClick={() => handleEdit(license.id, license.heading, license.address, license.fax, license.phone,  license.email )}
               >Edit</button></td>
              <td><button className='tablebutton'
              onClick={() => handleDelete(license.id)}
              >Delete</button></td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div >
  );
}
